import { Component, Input } from '@angular/core';

@Component({
  selector: 'brand-reviews',
  templateUrl: 'brand-reviews.html',
  styleUrls: ['brand-reviews.scss'],
})
export class BrandReviewsComponent {

  @Input() reviewsTitle: string = `<h2 class="reviews_titleContent">SUCCESS STORIES</h2>`;
  @Input() disclaimer: string = '*Individual results may vary';
  @Input() star: string = "https://cdn.drmartypets.com/images/5stars.png";
  @Input() reviews: any[] = [];

  Arr = Array;

  constructor() { }


}